import { Breadcrumb, Card, Col, Icon, Layout, Row, Tabs } from 'antd'
import DocumentsCont from '../../../components/Common/Documents/DocumentsCont'
import TimelineFeedCont from '../../../components/Common/TimelineFeed/TimelineFeedCont'
import Contracts from '../../../components/Finance/Lender/Contracts'
import Details from '../../../components/Finance/Lender/Details'
import LenderDetails from '../../../components/Finance/Lender/LenderDetails'
import Profile from '../../../components/Finance/Lender/Profile'
import PageTitle from '../../../elements/PageTitle'
import React from 'react'
import { get, isEmpty} from 'lodash'
import { withRouter } from 'react-router-dom'

const { Content } = Layout
const { TabPane } = Tabs

function Lender(props) {
  const { member, lender, repsList, fetching, fetch, prev,
  } = props

  return (
    <Content style={{ margin: '0px 0px' }}>
      <Card>
        <Row>
          <Breadcrumb>
            <Breadcrumb.Item href="#/">Home</Breadcrumb.Item>
            <Breadcrumb.Item href="#/finance">Finance</Breadcrumb.Item>
            <Breadcrumb.Item href="#/finance/lenders/list">Finance List</Breadcrumb.Item>
            <Breadcrumb.Item>{member.fn}</Breadcrumb.Item>
          </Breadcrumb>
          <PageTitle
            title={'Finance Management Area'}
            subtitle={'Finance Management Area.'}
            color={'#427035'}
            iconType={'file-unknown'}
          />
        </Row>
      </Card>
      {!isEmpty(lender) ? (
      <Row gutter={16} style={{ padding: 10 }}>
        <Col>
          <Details {...{ lender, member, fetching }} />
          <Card style={{ minHeight: '542px' }}>
            <Row style={{ paddingTop: '10px' }}>
              <Tabs
                defaultActiveKey={get(props, 'location.hash') || '#profile'}
                onChange={key => props.history.push(key)}>
                <TabPane
                  tab={
                    <span>
                      <Icon type="user" />
                      Profile
                    </span>
                  }
                  key="#profile">
                  <Profile {...{ repsList, member, fetching, fetch }} />
                </TabPane>
                <TabPane
                  tab={
                    <span>
                      <Icon type="info-circle-o" />
                      Finance Partner Details
                    </span>
                  }
                  key="#details">
                  <LenderDetails {...props} loading={fetching} />
                </TabPane>
                <TabPane
                  tab={
                    <span>
                      <Icon type="lock" />
                      Accounts
                    </span>
                  }
                  key="#contracts">
                  <Contracts {...{ member, lender, loading: fetching }} />
                </TabPane>
                <TabPane
                  tab={
                    <span>
                      <Icon type="folder-open" />
                      Documents
                    </span>
                  }
                  key="#docs">
                  <DocumentsCont owner={member} />
                </TabPane>
                <TabPane
                  tab={
                    <span>
                      <Icon type="file-text" />
                      Notes
                    </span>
                  }
                  key="#note">
                  <TimelineFeedCont owner={lender._id} hideNotification={true} />
                </TabPane>
              </Tabs>
            </Row>
          </Card>
        </Col>
      </Row>
      ) : (
        <Row gutter={16} style={{ padding: 10 }}>
          <Col>
            <Card style={{ minHeight: '542px' }}>
              <Row style={{ paddingTop: '10px' }}>
                <div className={"grid justify-items-stretch"}>
                <button onClick={() => window.history.back()} className={"p-1 rounded-md justify-self-center bg-red-700 hover:bg-white font-bold text-white hover:text-red-500"}>CLICK HERE TO RETURN TO LISTING</button>
                </div>
              </Row>
            </Card>
          </Col>
        </Row>
      )
      }
    </Content>
  )
}

export default withRouter(Lender)
